import PropTypes from "prop-types";
import PackageCard from "@components/PackageCard";
import packages from "@data/PackagesData"; // Import the packages data
import { motion } from "framer-motion"; // Import framer-motion
import { useInView } from "react-intersection-observer"; // Import useInView
// import Button from "./Button";

const cardVariants = {
	hidden: { opacity: 0, y: 50 },
	visible: { opacity: 1, y: 0, transition: { duration: 1 } },
};

function PackagesSection({ number, all }) {
	let packagesToRender;

	if (all) {
		packagesToRender = packages;
	} else if (number) {
		packagesToRender = packages.slice(0, number);
	} else {
		packagesToRender = packages;
	}

	return (
		<div className="py-6 flex flex-col gap-12 items-center">
			<div className="flex flex-col gap-6 lg:flex-row flex-wrap justify-center items-center">
				{packagesToRender.map((pkg) => (
					<PackageCardWrapper key={pkg.title} pkg={pkg} />
				))}
			</div>
		</div>
	);
}

const PackageCardWrapper = ({ pkg }) => {
	const [ref, inView] = useInView({
		triggerOnce: true,
		threshold: 0.2, // Adjust threshold to 60%
	});

	return (
		<motion.div
			ref={ref}
			initial="hidden"
			animate={inView ? "visible" : "hidden"}
			variants={cardVariants}
			className="h-full"
		>
			<PackageCard
				title={pkg.title}
				price={pkg.price}
				description={pkg.description}
				priceId={pkg.priceId}
				className="h-full"
			/>
		</motion.div>
	);
};

PackageCardWrapper.propTypes = {
	pkg: PropTypes.shape({
		title: PropTypes.string.isRequired,
		price: PropTypes.number.isRequired,
		description: PropTypes.string.isRequired,
		priceId: PropTypes.string.isRequired,
	}).isRequired,
};

PackagesSection.propTypes = {
	number: PropTypes.number,
	all: PropTypes.bool,
};

export default PackagesSection;
